<template>
    <div class="sidebar sidebar-left offcanvas offcanvas-start" id="leftSidebar">
        <div class="sidebar-content offcanvas-body">
            <div class="logo">
                <router-link :to="Links.Url(Links.Home)" :title="appData.name" class="d-block">
                    <img :src="Web.Url(appData.default.logo)" :alt="appData.name" />
                </router-link>
            </div>
            <nav class="main-menu">
                <perfect-scrollbar class="scrollbar-sidebar" id="collapseMenu">
                    <ul class="nav metimenu">
                        <li v-for="(r, index) in menu" :key="r">
                            <template v-if="r.child">
                                <a data-bs-toggle="collapse" :href="'#collapse_menu_' + index" :title="r.text" role="button" :class="{ 'collapsed' : !isSelectChild(r.child) }"  :aria-expanded="isSelectChild(r.child)" :aria-controls="'collapse_menu_' + index">
                                    <i :class="r.class"></i>
                                    <span>{{ r.text }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                    <i class="fa fa-chevron-right"></i>
                                </a>
                                <div data-bs-parent="#collapseMenu" class="collapse" :class="{ 'show' : isSelectChild(r.child) }" :id="'collapse_menu_' + index">
                                    <ul class="sub-menu">
                                        <li v-for="c in r.child" :key="c">
                                            <router-link :to="c.link">
                                                <i :class="c.class"></i>
                                                <span>{{ c.text }}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                            <template v-else>
                                <router-link :to="r.link" :title="r.text"><i :class="r.class"></i><span>{{ r.text }}</span></router-link>
                            </template>
                        </li>
                        <li>
                            <a href="javascript:void(0)" title="Çıkış" @click="logout"><i class="fa fa-right-from-bracket"></i><span>Çıkış</span></a>
                        </li>
                    </ul>
                </perfect-scrollbar>
            </nav>
        </div>
    </div>
</template>
<script>
    import { reactive, toRefs } from "vue";
    import { useRoute } from "vue-router";

    import { Offcanvas } from "bootstrap";

    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { C, appData } from "@/helpers/global";
    import { Web } from "@/helpers/web";

    import { PerfectScrollbar } from "vue3-perfect-scrollbar";
    import { PersonService } from "@/services/api/person";

    export default {
        components: {
            PerfectScrollbar,
        },
        setup() {
            const route = useRoute();

            const e = reactive({
                isSelectChild(child) {
                    for (var i = 0; i < child.length; i++) {
                        if (e.isSelectUrl(child[i].link)) {
                            return true;
                        }
                    }
                    return false;
                },
                isSelectUrl(link) {
                    if (C.Str(route.path) == link) { return true; }
                    return (C.Str(route.path).indexOf(link.replace(/\/0/g, '')) == 0);
                },
                menu: [
                    Links.GetMenu("Anasayfa", "home", Links.Home),
                    Links.GetMenu("Üye Yönetimi", "users", [
                        Links.GetMenu("Öğrenciler", "user", Links.Customer.List, 1),
                        Links.GetMenu("Danışman Adayları", "user-plus", Links.Customer.List, 2),
                        Links.GetMenu("Danışmanlar", "user-tie", Links.Customer.List, 3),
                        Links.GetMenu("Eğitmenler", "chalkboard-user", Links.Customer.List, 4),
                    ]),
                    Links.GetMenu("Eğitim Sistemi", "person-chalkboard", [
                        Links.GetMenu("Sınav Türleri", "layer-group", Links.LessonArea.List),
                        Links.GetMenu("Sınav Alanı", "arrows-split-up-and-left", Links.LessonGroup.List),
                        Links.GetMenu("Dersler", "book", Links.Lesson.List),
                        Links.GetMenu("Ders Hocaları", "chalkboard-user", Links.LessonTeacher.List),
                        Links.GetMenu("Nasıl Çalışılır", "person-chalkboard", Links.HowToStudy.List),
                        Links.GetMenu("Sınıf", "chalkboard", Links.ClassRoom.List),
                        //Links.GetMenu("Çıkmış Sorular", "building-flag", Links.OutstandingQuestions.List),
                        //Links.GetMenu("Denemeler", "flask-vial", Links.Trial.List),
                    ]),
                    Links.GetMenu("Ödeme Yönetimi", "credit-card", [
                        Links.GetMenu("Bekleyen Ödemeler", "clock", Links.Payment.List, 1),
                        Links.GetMenu("Onaylanan Ödemeler", "check", Links.Payment.List, 2),
                        Links.GetMenu("İptal Edilen Ödemeler", "ban", Links.Payment.List, 3),
                        Links.GetMenu("Hakediş", "briefcase", Links.Payment.ProcessList),
                    ]),
                    Links.GetMenu("Doküman Yönetimi", "folder-tree", [
                        Links.GetMenu("Pdfler", "file-pdf", Links.GlobalFile.List, 1),
                        Links.GetMenu("Videolar", "video", Links.GlobalFile.List, 2),
                        Links.GetMenu("Doküman Kategorileri", "list", Links.GlobalFile.CategoryList),
                    ]),
                    Links.GetMenu("Kaynak Yönetimi", "book", Links.ResourceBook.List),
                    Links.GetMenu("Test Havuzu", "flask-vial", Links.TestPool.List),
                    Links.GetMenu("Soru Havuzu", "question", Links.QuestionPool.List),
                    Links.GetMenu("Paketler", "box-open", Links.Package.List),
                    Links.GetMenu("Destek/Talep", "address-card", Links.Contact.List),
                    Links.GetMenu("Sözleşmeler", "handshake", Links.Contract.List),
                    Links.GetMenu("Duyurular", "bullhorn", Links.Announcement.List),

                    //Links.GetMenu("İletiler", "paper-plane-o", Links.Message.List),
                    Links.GetMenu("Sistem Yönetimi", "gears", [
                        Links.GetMenu("Genel Ayarlar", "gear", Links.Setting.General),                        
                        Links.GetMenu("İletişim", "circle-info", Links.Setting.Contact),
                        Links.GetMenu("E-posta", "envelope", Links.Setting.Email),
                        Links.GetMenu("Sms", "comment-sms", Links.Setting.Sms),
                        Links.GetMenu("İleti Gönderim", "envelopes-bulk", Links.Setting.Send),
                        Links.GetMenu("İçeri Aktar", "upload", Links.Setting.Import),
                        Links.GetMenu("Dışarı Aktar", "download", Links.Setting.Export),

                        Links.GetMenu("Kullanıcılar", "people-group", Links.Person.List),
                        Links.GetMenu("Roller", "key", Links.Role.List),
                    ]),
                ],
                logout() {
                    PersonService.Logout(true);
                },
            });
            return { ...toRefs(e) };
        },
        watch: {
            $route(to, from) {
                let left = document.getElementById('leftSidebar');
                if (left) {
                    let offCanvas = Offcanvas.getInstance(left);
                    if (offCanvas) {
                        offCanvas.hide();
                    }
                }
            }
        }
    };
</script>
